module.exports = __webpack_public_path__ + "static/mitre10-bg-mobile-75c98c164e865f5451fba82453f14e62.jpg";